// Smartzone
export function setSmartzone(body) {
  return {
    path: 'smartzone',
    method: 'POST',
    body: JSON.stringify(body),
  };
}
export function getSmartzone(smartzoneId) {
  return { path: `smartzone/${smartzoneId}` };
}

export function configureGroupDpsks(buildingId) {
  return {
    path: 'dpsk/group/property',
    method: 'POST',
    body: JSON.stringify({
      property_id: buildingId,
    }),
  };
}

export function removeBuildingSmartzoneAndDpsks(buildingId) {
  return {
    path: `smartzone/property/${buildingId}`,
    method: 'DELETE',
  };
}

export function getGroupDpsk(unitId) {
  return {
    path: `dpsk/group/unit/${unitId}`,
    method: 'GET',
    skipBodyCheck: true,
  };
}

export function createGroupDpsk(unitId) {
  return {
    path: 'dpsk/group',
    method: 'POST',
    body: JSON.stringify({ unit_id: unitId }),
  };
}
export function deleteGroupDpsk(unitId) {
  return {
    path: `dpsk/group/unit/${unitId}`,
    method: 'DELETE',
  };
}
